<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToMarronsGame()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/marrons/Asset 0.png" alt="">

    <span v-if="selected_text == 0" id="marrons_game_text">Dag der Marrons</span>
    <span v-html="texts[selected_text]" id="marron_game_intro_text" :style="selected_text > 0 ? 'margin-top: 7%;' : ''"></span>

    <img draggable="false" class="clickable" v-show="texts.length > (selected_text + 1)" @click="nextText()" id="next_btn" src="./../../assets/images/Asset 51.png" alt="">
    <img draggable="false" class="clickable" v-show="selected_text > 0" @click="prevText()" id="prev_btn" src="./../../assets/images/Asset 51.png" alt="">

    <img v-show=" ! $store.getters['app/overlays'].skip_intro ? texts.length == (selected_text + 1) : true"  draggable="false" @click="goToMarronsGame()" class="clickable" id="inheems_game_intro_btn" src="./../../assets/images/Asset 30.png" alt="">

  </span>
</template>

<script>

export default {
  name: "MarronsIntro",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {
      selected_text: 0,
      texts: [
        "Lang geleden, toen mensen uit Afrika naar Suriname werden gebracht als slaven, begonnen sommigen van hen te dromen van vrijheid. Deze dappere mensen wilden niet langer onderdrukt worden door de plantage-eigenaren, die hen slecht behandelden. Ze besloten om te ontsnappen en vonden hun toevlucht in de dichte bossen rondom de plantages. Daar noemden ze zichzelf \"marrons.\" De marrons gaven nooit op. Ze bleven vechten voor hun vrijheid en het recht om behandeld te worden als echte mensen. Ze werden zo sterk en dapper dat het koloniale bestuur met hen moest onderhandelen over vrede.",

        "Op 10 oktober vieren de nakomelingen van deze dappere marrons een heel speciale dag. Op die dag herdenken ze dat hun voorouders in het jaar 1760 het allereerste verdrag voor hun vrijheid sloten. Het is een dag van trots, herinnering en eren van hun voorouders. <br><br> Dus, de Dag der Marrons is een dag vol geschiedenis en moedige verhalen over mensen die streden voor vrijheid. Het herinnert ons eraan dat we nooit moeten opgeven in de strijd voor gerechtigheid en gelijkheid.",

        "Wist je dat er een speciale kunst is die Tembe heet? Het wordt gemaakt door de Marrons. Ze gebruiken allerlei patronen om verhalen en avonturen te vertellen.<br><br> Ze maken dit kunstwerk door in hout te snijden of het te schilderen. Zet de stukjes van deze puzzel in elkaar en ontdek hoe een Tembe-kunstwerk eruitziet! <br><br> Veel plezier!"
      ]
    };
  },

  methods: {
    goToMarronsGame() {
      this.$store.dispatch('app/asyncUpdateSkipIntro', {
          skip_intro: true,
      });
      this.$router.push('/marrons/game');
    },
    nextText() {
      this.selected_text++;
    },
    prevText() {
      this.selected_text--;
    },
    goToMarronsGame() {
      this.$router.push('/marrons/start');
    },
  },

  computed: {}
};
</script>

<style>
  #marrons_game_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 40%;
    left: 31%;
    color: white;
    font-size: 4.5vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }
  #marron_game_intro_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 10.5%;
    width: 50%;
    left: 25%;
    color: white;
    font-size: 2vw;
    text-align: center;
    filter: drop-shadow(5px 5px 5px #3d3d3d);
    -webkit-filter: drop-shadow(5px 5px 5px #3d3d3d);
  }

  #canvas {
    z-index: 1;
  }
  #canvasparent {
    padding-top: 10%;
  }
</style>


